import { Component } from '@angular/core';
import { Mail } from 'src/app/shared/models/mails/mail';
@Component({
  selector: 'app-courrier-details',
  templateUrl: './courrier-details.component.html',
  styleUrls: ['./courrier-details.component.scss'],
})
export class CourrierDetailsComponent {
  public newMailActive: Mail;

  receiveNewMail(mail: Mail) {
    this.newMailActive = mail;
  }
}
